const SOAP_HEADER = `<?xml version="1.0" encoding="utf-8"?><soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" 
xmlns:m="http://schemas.microsoft.com/exchange/services/2006/messages" xmlns:xsd="http://www.w3.org/2001/XMLSchema" 
xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types">
<soap:Header><RequestServerVersion Version="Exchange2013" xmlns="http://schemas.microsoft.com/exchange/services/2006/types" 
soap:mustUnderstand="0" /></soap:Header>`;
const SOAP_FOOTER = '</soap:Envelope>';
export default {
  getForwardXML(id, changeKey, email) {
    return `${SOAP_HEADER}<soap:Body><m:CreateItem MessageDisposition="SendAndSaveCopy"><m:Items><t:ForwardItem>
    <t:ToRecipients><t:Mailbox><t:EmailAddress>${email}</t:EmailAddress></t:Mailbox></t:ToRecipients>
    <t:ReferenceItemId Id="${id}" ChangeKey="${changeKey}"></t:ReferenceItemId><t:NewBodyContent BodyType="HTML">
    </t:NewBodyContent></t:ForwardItem></m:Items></m:CreateItem></soap:Body>${SOAP_FOOTER}`;
  },
  getItemDataXML(id) {
    return `${SOAP_HEADER}<soap:Body><GetItem xmlns="http://schemas.microsoft.com/exchange/services/2006/messages" 
    xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types"><ItemShape><t:BaseShape>IdOnly</t:BaseShape></ItemShape>
    <ItemIds><t:ItemId Id="${id}"/></ItemIds></GetItem></soap:Body>${SOAP_FOOTER}`;
  },
  createNewContactXML(contact) {
    return `${SOAP_HEADER}<soap:Body><m:CreateItem MessageDisposition="SaveOnly"><m:Items><t:Contact>
    <t:FileAsMapping>LastCommaFirst</t:FileAsMapping><t:GivenName>${contact.person.information.firstName}</t:GivenName>
    <t:MiddleName>${contact.person.information.middleName}</t:MiddleName>
    <t:CompanyName>${contact.company.information.name}</t:CompanyName>
    <t:EmailAddresses><t:Entry Key="EmailAddress1">${contact.person.contact.email}</t:Entry>
    <t:Entry Key="EmailAddress2">${contact.person.contact.email}</t:Entry>
    </t:EmailAddresses><t:Surname>${contact.person.information.familyName}</t:Surname>
    <t:PhoneNumbers>
    <t:Entry Key="HomePhone"> +${contact.person.contact.primaryCode}-${contact.person.contact.primary}</t:Entry>
    </t:PhoneNumbers>
    </t:Contact>
   </m:Items></m:CreateItem>
    </soap:Body>${SOAP_FOOTER}`;
  },
  getOutlookContacts() {
    return `${SOAP_HEADER}<soap:Body><m:FindItem Traversal="Shallow"><m:ItemShape><t:BaseShape>AllProperties</t:BaseShape>
    <t:AdditionalProperties><t:FieldURI FieldURI="contacts:DisplayName" /></t:AdditionalProperties></m:ItemShape>
    <m:IndexedPageItemView MaxEntriesReturned="999" Offset="0" BasePoint="Beginning" /><m:ParentFolderIds>
    <t:DistinguishedFolderId Id="contacts" /></m:ParentFolderIds></m:FindItem></soap:Body>${SOAP_FOOTER}`;
  },
};



// WEBPACK FOOTER //
// ./src/ews/soap.js